/**
 * localStorage store for the desktop sidebar collapse. The rail is chrome, not
 * account data, so the preference is per-browser and unauthenticated — it
 * survives a reload and a sign-out without a round trip.
 */
export const SIDEBAR_COLLAPSED_KEY = 'tt_sidebar_collapsed'

export function readSidebarCollapsed(): boolean {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === '1'
  } catch {
    return false
  }
}

export function writeSidebarCollapsed(collapsed: boolean): void {
  try {
    if (collapsed) localStorage.setItem(SIDEBAR_COLLAPSED_KEY, '1')
    else localStorage.removeItem(SIDEBAR_COLLAPSED_KEY)
  } catch {
    // Quota / privacy mode — the preference just won't survive a reload.
  }
}
